import { Instagram, Linkedin, Twitter, ArrowUp } from "lucide-react";
import { NAV_LINKS, SOCIAL_LINKS, CONTACT_EMAIL, LOGO_URL } from "@/constants/siteData";

const ICONS = { Instagram, Linkedin, Twitter };

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t-2 border-border">
      <div className="container-xl py-14">
        <div className="flex flex-col gap-12 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <a href="#hero" className="flex items-center">
              <img
                src={LOGO_URL}
                alt="Stoyga"
                className="h-7 w-auto object-contain grayscale invert mix-blend-screen"
              />
            </a>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              A documentary production house for obsessional, long form
              non-fiction — features, docuseries and commissioned storytelling.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-2">
            <div>
              <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-muted-foreground">
                Studio
              </p>
              <ul className="mt-4 flex flex-col gap-3">
                {NAV_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-muted-foreground">
                Connect
              </p>
              <ul className="mt-4 flex flex-col gap-3">
                <li>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors"
                  >
                    {CONTACT_EMAIL}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col-reverse items-center justify-between gap-4 border-t-2 border-border pt-8 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            © {year} Stoyga Productions. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="font-mono-brand text-xs uppercase tracking-[0.18em] text-muted-foreground">
              Status: In Production
            </span>
            <a
              href="#hero"
              aria-label="Back to top"
              className="flex h-8 w-8 items-center justify-center border-2 border-border text-muted-foreground hover:border-foreground hover:text-foreground transition-colors"
            >
              <ArrowUp className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
